import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";
import { Divider, Grid, Paper } from "@material-ui/core";

import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";

import { useStyles } from "./DetailAuthor.css";
import { url } from "../../../../config/config";
import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";

class DetailAuthor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authorId: this.props.match.params.authorId,
      authorData: [],
    };
  }

  async componentDidMount() {
    const response = await Axios.get(
      `${url}/api/authors/${this.state.authorId}`
    );
    this.setState({
      authorData: response.data,
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          <AdminPageTitle
            title="Author Details"
            refreshUrl={this.props.match.url}
          />
          <Divider />
          {this.state.authorData.length !== 0 ? (
            <Grid container spacing={3} className={classes.gridContainer}>
              <Grid item xs sm={3}>
                <Paper style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={this.state.authorData.imageUrl}
                    alt="Author"
                    style={{ width: 250, height: 250 }}
                  />
                </Paper>
              </Grid>
              <Grid item xs sm>
                <Paper>
                  <div
                    style={{
                      width: "100%",
                      padding: 10,
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      fontSize: 30,
                      fontWeight: "bold",
                    }}
                  >
                    {this.state.authorData.firstName}
                    {this.state.authorData.middleName}{" "}
                    {this.state.authorData.lastName}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      padding: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: 20,
                    }}
                  >
                    {this.state.authorData.description}
                  </div>
                  <div
                    style={{
                      padding: 10,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <PhoneIcon /> {this.state.authorData.phone}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <EmailIcon /> {this.state.authorData.email}
                    </div>
                  </div>
                </Paper>
              </Grid>
            </Grid>
          ) : (
            <CustomLoader />
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(DetailAuthor);
